export default function () {
  const log = useLogger('useProtex')

  async function hasFitment(fitment: ProtexFitment, productLineSlug?: string, endpoint: string = 'rt') {
    const url: ProtexEndpointUrl = productLineSlug
      ? `/api/protex/${endpoint}/${productLineSlug}/`
      : `/api/protex/${endpoint}/`

    const { make, model, year, bed, body } = fitment

    // Check if our product + fitment combination has protex
    const resp = await $fetch(url, {
      query: {
        make,
        model,
        year,
        bed,
        body,
      },
    }).catch((e) => {
      // If we couldn't fetch because of a network error, we won't have a status to check
      if (e.status && e.status !== 404) {
        log.error('Failed to fetch protex data', e)
      }
    })

    return resp?.hasApplications ?? false
  }

  return {
    hasFitment,
  }
}

type ProtexEndpointUrl = `/api/protex/${string}/${string}/` | `/api/protex/${string}/`

type ProtexFitment = Pick<Fitment, 'make' | 'model' | 'year' | 'bed' | 'body'>
